const frExtends = {
    //missing
    "Create Task": "Créer étape",
    "Append Task": "Ajouter étape",
    "Sequence Flow": "Transformer en connexion sans erreur",
    "Conditional Flow": "Transformer en connexion en erreur",
    //override"
    "Remove": "Supprimer",
    //custom
    "Connect": "Ajouter une connexion",
    "Connect conditional": "Ajouter une connexion en erreur",
};

export default frExtends;